import React from 'react'
import Fragment from '../common/fragment'

function FragmentDF(props) {
  return (
    <Fragment pos="ffff" {...props}>
      <p>
      Espejos que no reflejarán nada. Imagen perdida en la oscuridad del reflejo. Espejos
mudos y dioses sordos. Espejos humeantes como chimeneas. ¿Quién se convertirá
en el dios?, ¿qué palabras dirá el mancebo?, ¿cuáles negruras amargarán la epifanía
y el reflejo? En este espejo solo veremos la noche. Espejohumeante.
Autómatas/Tezcatlipoca. Salamanca/Tenochtitlán. Muñeco/mancebo. Teatro
Ojo/Espejo humeante.
      </p>
    </Fragment>
  )
}


export default FragmentDF
